import { render } from "./AdminLogin.vue?vue&type=template&id=40e20c0a"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/sirimmatrix/sirimmatrix/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__